import React, { PureComponent } from 'react'
import { Panel, Button } from 'react-bootstrap'
import { permissions } from '../../../constants/backendIds'
import { getFieldsPermisions } from '../../../util/permisionFunctions'
import { compareObjects } from '../../../util/utils'
import InputDatePicker from '../../../components/commons/form/InputDatePicker'
import { Field } from 'redux-form'
import ComponentTitle from '../../../containers/dossiers/commons/ComponentTitlePage'

export default class BookingAndDelivery extends PureComponent {
  constructor () {
    super()
    this.state = {
      open: false,
      fieldsConfiguration: {
        confirmationDoneButton: null,
        confirmationDate: null,
        bookingDate: null,
        deliveryDate: null,
        anticipatedDate: null
      }
    }
  }

  initializePermisions (props) {
    const fieldKeys = Object.keys(this.state.fieldsConfiguration)
    const newState = getFieldsPermisions(props.componentConfiguration.fieldsConfiguration, fieldKeys, props.componentConfiguration.permission)
    this.setState({ fieldsConfiguration: newState.fieldsConfiguration })
  }

  toggleComponent () {
    if (this.state.open) {
      this.props.actions.setActiveSection(false)
    }
    this.setState({ open: !this.state.open })
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (this.props.dossier && this.props.dossier.dossierId) {
      if (!compareObjects(prevProps.componentConfiguration || {}, this.props.componentConfiguration, true)) {
        this.initializePermisions(this.props)
      }
      if (!prevProps.open && this.props.open) {
        this.setState({ open: true })
      }
    }
    return prevProps
  }

  componentDidUpdate () {
    // don't remove use for getsnapshot
  }

  componentDidMount () {
    this.initializePermisions(this.props)
  }

  render () {
    const {
      t, dossierId, readOnlyFields, actions: { confirmDateWithIdByStage }, dossier: { bookingAndDelivery }
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.BOOKING_AND_DELIVERY.'

    return (
      <div className="dossier-Component">
        <div className="header-panel" onClick={() => this.toggleComponent()}>
          <ComponentTitle
            componentCode="BOOKING_AND_DELIVERY"
            componentOpen={this.state.open}
            // extraInfo={'info extra'}
            // extraData={<a className="_Btn accept">texto</a>}
          />
        </div>
        <Panel expanded={this.state.open} onToggle={() => { }}>
          <Panel.Collapse>
            {this.state.fieldsConfiguration.confirmationDoneButton && this.state.fieldsConfiguration.confirmationDoneButton.permission === permissions.editable && !bookingAndDelivery?.confirmationDate && (
              <div className='flexInLine al-R'>
                <Button className='_Btn new' onClick={() => confirmDateWithIdByStage(dossierId)} >
                  {t(`${tKey}DELIVERED`)}
                </Button>
              </div>
            )}
            <div className='fieldsContainer'>
              {this.state.fieldsConfiguration.bookingDate && this.state.fieldsConfiguration.bookingDate.permission !== permissions.hidden && (
                <Field
                  component={InputDatePicker}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="bookingDate"
                  key="bookingDate"
                  name="bookingAndDelivery.bookingDate"
                  controlLabel={t(`${tKey}BOOKING_DATE`)}
                  placeholder={t(`${tKey}BOOKING_DATE`)}
                  disabled={readOnlyFields || this.state.fieldsConfiguration.bookingDate.permission !== permissions.editable}
                  customClass={readOnlyFields || this.state.fieldsConfiguration.bookingDate.permission !== permissions.editable ? 'disabled' : ''}
                />
              )}
              {this.state.fieldsConfiguration.anticipatedDate && this.state.fieldsConfiguration.anticipatedDate.permission !== permissions.hidden && (
                <Field
                  component={InputDatePicker}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="anticipatedDate"
                  key="anticipatedDate"
                  name="bookingAndDelivery.anticipatedDate"
                  controlLabel={t(`${tKey}ANTICIPATED_DATE`)}
                  placeholder={t(`${tKey}ANTICIPATED_DATE`)}
                  disabled={readOnlyFields || this.state.fieldsConfiguration.anticipatedDate.permission !== permissions.editable}
                  customClass={readOnlyFields || this.state.fieldsConfiguration.anticipatedDate.permission !== permissions.editable ? 'disabled' : ''}
                />
              )}
              {this.state.fieldsConfiguration.deliveryDate && this.state.fieldsConfiguration.deliveryDate.permission !== permissions.hidden && (
                <Field
                  component={InputDatePicker}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="deliveryDate"
                  key="deliveryDate"
                  name="bookingAndDelivery.deliveryDate"
                  controlLabel={t(`${tKey}DELIVERY_DATE`)}
                  placeholder={t(`${tKey}DELIVERY_DATE`)}
                  disabled={readOnlyFields || this.state.fieldsConfiguration.deliveryDate.permission !== permissions.editable}
                  customClass={readOnlyFields || this.state.fieldsConfiguration.deliveryDate.permission !== permissions.editable ? 'disabled' : ''}
                />
              )}
              {this.state.fieldsConfiguration.confirmationDate && this.state.fieldsConfiguration.confirmationDate.permission !== permissions.hidden && (
                <Field
                  component={InputDatePicker}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="confirmationDate"
                  key="confirmationDate"
                  name="bookingAndDelivery.confirmationDate"
                  controlLabel={t(`${tKey}CONFIRM_DATE`)}
                  placeholder={t(`${tKey}CONFIRM_DATE`)}
                  disabled={readOnlyFields || this.state.fieldsConfiguration.confirmationDate.permission !== permissions.editable}
                  customClass={readOnlyFields || this.state.fieldsConfiguration.confirmationDate.permission !== permissions.editable ? 'disabled' : ''}
                />
              )}
            </div>
          </Panel.Collapse>
        </Panel>
      </div>
    )
  }
}
